import dayjs from 'dayjs';
import { onMounted, onUnmounted } from 'vue';

const STORAGE_KEY = 'sion_token_refresh_event';
const EVENT_TYPE = 'TOKEN_REFRESHED';

/**
 * Composable for emitting and listening to token refresh events.
 * Uses localStorage events for cross-tab communication.
 *
 * @param {Function} onTokenRefreshed - Callback to execute when a token refresh event is received
 */
export function useTokenRefreshEvent(onTokenRefreshed) {
  const emitTokenRefreshEvent = () => {
    const event = {
      type: EVENT_TYPE,
      timestamp: dayjs().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(event));
  };

  const handleStorageEvent = (event) => {
    if (event.key === STORAGE_KEY && event.newValue) {
      try {
        const data = JSON.parse(event.newValue);
        if (data?.type === EVENT_TYPE && onTokenRefreshed) {
          onTokenRefreshed();
        }
      } catch (error) {
        console.error('Failed to parse token refresh event:', error);
      }
    }
  };

  onMounted(() => {
    window.addEventListener('storage', handleStorageEvent);
  });

  onUnmounted(() => {
    window.removeEventListener('storage', handleStorageEvent);
  });

  return {
    emitTokenRefreshEvent,
  };
}
